import React from "react";
import { getCryptoAsset } from "../../../utils/cryptoAssets";
import ListingItem from "../ListingItem";
export default function AccountAssetItem(props) {
    const { type, amount, subLabel, subValue } = props;
    const { icon: Icon, name: label } = getCryptoAsset(type);
    return (React.createElement(ListingItem, { icon: Icon, label: label, subLabel: subLabel, value: amount, subValue: subValue }));
}
//# sourceMappingURL=AccountAssetItem.js.map